import { CorrectiveActionsText } from "./CorrectiveActionsText";
export default CorrectiveActionsText;
